import { PanelConnectionType } from '../enums';

export const invertConnectionTypeCfn = (connectionType: PanelConnectionType): PanelConnectionType => {
	let invertedType = PanelConnectionType.Inline;

	switch (connectionType) {
		case PanelConnectionType.Inside:
			invertedType = PanelConnectionType.Outside;
			break;
		case PanelConnectionType.Outside:
			invertedType = PanelConnectionType.Inside;
			break;
		default:
	}

	return invertedType;
};
